import { Trans } from 'react-i18next'

import {
  moleculasBigPNG,
  moleculasBigWEBP,
  moleculasSecondPNG,
  moleculasSecondWEBP,
} from '~/pages/onboarding/intro/libs/components/Biology/constants'
import { BiologyStyles as S } from '~/pages/onboarding/intro/libs/components/Biology/styles'
import { Container } from '~/shared/components/Container'

type Props = { onCLick: VoidFunction }

const Biology = ({ onCLick }: Props) => (
  <S.Root>
    <picture>
      <source srcSet={moleculasBigWEBP} type="image/webp" />
      <S.MoleculaBig src={moleculasBigPNG} alt="Moleculas Big" />
    </picture>

    <Container>
      <S.Content>
        <S.Title>
          <Trans
            i18nKey="onboarding.biologyIntro.title"
            components={{ span: <span /> }}
          />
        </S.Title>

        <S.Subtitle>
          <Trans i18nKey="onboarding.biologyIntro.subtitle" />

          <picture>
            <source srcSet={moleculasSecondWEBP} type="image/webp" />
            <S.MoleculaSmall src={moleculasSecondPNG} alt="Moleculas Small" />
          </picture>
        </S.Subtitle>
      </S.Content>

      <S.StyledButton type="button" onClick={onCLick}>
        <Trans i18nKey="actions.continue" />
      </S.StyledButton>
    </Container>
  </S.Root>
)

export default Biology
